// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1Ojq9","title":"Header_title__1fsEJ","left":"Header_left__3Htbm","clinicName":"Header_clinicName__Rc18a"};